import { MOTIVATION_MANAGEMENT } from "../types/actions";

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case MOTIVATION_MANAGEMENT.GET_MOTIVATION_LIST:
            return { ...state, motivation_list: action.payload };
        case MOTIVATION_MANAGEMENT.ADD_NEW_MOTIVATION_SUCCESS:
            return {
                ...state,
                motivation_list: {
                    ...state.motivation_list,
                    results: [...state.motivation_list.results, action.payload],
                    count: state.motivation_list.count + 1
                }
            };
        case MOTIVATION_MANAGEMENT.UPDATE_MOTIVATION_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const index = state.motivation_list.results.findIndex((item) => item.id === action.payload.id);
            return {
                ...state,
                motivation_list: {
                    ...state.motivation_list,
                    results: [
                        ...state.motivation_list.results.slice(0, index),
                        action.payload,
                        ...state.motivation_list.results.slice(index + 1)
                    ]
                }
            };
        default:
            return state;
    }
};
